"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _EmailSettingsComponent = _interopRequireDefault(require("./EmailSettingsForm/EmailSettingsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var profileAndSecurityWidgetClasses = (0, _cssClassesHelper.getBEMClasses)(['profile-and-security-widget']);
var EmailSettingsCard = function EmailSettingsCard(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
    header: /*#__PURE__*/_react["default"].createElement("div", {
      className: profileAndSecurityWidgetClasses('header')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: profileAndSecurityWidgetClasses('header-text')
    }, "Email Settings")),
    customClass: "profile-and-security-widget",
    classModifiers: ['sm']
  }, /*#__PURE__*/_react["default"].createElement(_EmailSettingsComponent["default"], {
    customClass: "retail-reset-password-form"
  }));
};
var _default = exports["default"] = EmailSettingsCard;